import type { DisplayedVehicleType } from './filterUtils';
import { getDefaultVehicleType, vehicleTypes } from './filterUtils';

const URL_PARAM_BY_CARLINE_GROUP = 'bycarlinegroup';
const URL_PARAM_BY_TYPE = 'bytype';
const URL_PARAM_BY_BODY_TYPE = 'bybodytype';
const URL_PARAM_BY_VEHICLE_TYPE = 'byvehicletype';

export const getVehicleTypePreset = (filterActive: boolean): DisplayedVehicleType[] => {
  const vehicleTypePreset = getURLParameterValue(URL_PARAM_BY_VEHICLE_TYPE);

  if (vehicleTypePreset && vehicleTypes.includes(vehicleTypePreset as DisplayedVehicleType)) {
    return [vehicleTypePreset as DisplayedVehicleType];
  }

  if (filterActive) {
    return getDefaultVehicleType();
  }

  return [];
};

export const getCarlineGroupPreset = (preFilteredCarlineGroup?: string): string[] => {
  const carlineGroupPreset = getURLParameterValue(URL_PARAM_BY_CARLINE_GROUP);

  if (typeof preFilteredCarlineGroup === 'string' && preFilteredCarlineGroup.length > 0) {
    return preFilteredCarlineGroup.split(',');
  }

  if (typeof carlineGroupPreset === 'string' && carlineGroupPreset.length > 0) {
    return carlineGroupPreset.split(',');
  }

  return [];
};

export const getBodyTypePreset = () => {
  let bodyTypePreset = getURLParameterValue(URL_PARAM_BY_BODY_TYPE);

  if (!bodyTypePreset) {
    // fallback to URL parameter used by former model finder
    bodyTypePreset = getURLParameterValue(URL_PARAM_BY_TYPE);
  }

  if (!bodyTypePreset) {
    return [];
  }

  return bodyTypePreset.split(',');
};

const getURLParameterValue = (urlParameter: string) => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const { search } = window.location;

  if (search) {
    const urlParams = new URLSearchParams(search);
    const urlParam = urlParams.get(urlParameter);

    return urlParam || undefined;
  }

  return undefined;
};
